<template>
  <div class="other" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-form class="form-box" label-position="top">
      <el-form-item label="全景开关">
        <el-switch v-model="vForm.switch_planet" class="switch-item" inactive-text="小行星开场"></el-switch>
        <el-switch v-model="vForm.switch_scene" class="switch-item" inactive-text="场景选择"></el-switch>
        <el-switch v-if="config.WEB == 4" v-model="vForm.switch_audio_background" class="switch-item" inactive-text="背景音乐"></el-switch>
        <el-switch v-if="config.WEB == 4" v-model="vForm.switch_audio_explain" class="switch-item" inactive-text="背景解说"></el-switch>
        <!--        <el-switch v-model="vForm.switch.auto_cruise" class="switch-item" inactive-text="自动巡航"></el-switch>-->
        <!--        <el-switch v-model="vForm.switch.gyroscope" class="switch-item" inactive-text="手机陀螺仪"></el-switch>-->
        <!--        <el-switch v-model="vForm.switch.vr" class="switch-item" inactive-text="VR眼镜"></el-switch>-->
        <!--        <el-switch v-model="vForm.switch.comment" class="switch-item" inactive-text="说说评论"></el-switch>-->
      </el-form-item>
      <template v-if="config.WEB == 4">
        <el-form-item label="背景音乐">
          <upload-audio v-model="vForm.background_media_id" class="v-mt-5" />
        </el-form-item>
        <el-form-item label="背景解说">
          <upload-audio v-model="vForm.explain_media_id" class="v-mt-5" />
        </el-form-item>
      </template>
    </el-form>
    <div class="panel-footer">
      <div class="btn btn-save" @click="doSubmit" v-loading="doSubmitLoading">保存</div>
      <div class="btn btn-cancel" @click="mutationSetTabActive('')">取消</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      works_id: this.$route.query.id,
      doSubmitLoading: false,
      vForm: {
        background_media_id: '',
        explain_media_id: '',
        switch_planet: true,
        switch_scene: true,
        switch_audio_background: false,
        switch_audio_explain: false,
      },
    };
  },

  created() {
    this.getDetail();
  },

  methods: {
    ...mapMutations('tour', {
      mutationSetTabActive: 'SET_TAB_ACTIVE',
    }),

    //获取全局设置数据
    async getDetail() {
      this.loading = true;
      try {
        let res = await this.api.works.detail({ works_id: this.works_id });
        let info = res.data.info ? res.data.info : {};
        for (let key in info) {
          if (info[key] != undefined) {
            this.vForm[key] = info[key];
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //保存
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.api.works.update({
          id: this.works_id,
          field_data: { info: this.vForm },
        });
        this.$message.success('保存成功');
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.other {
  width: 350px;
  max-height: 500px;

  position: relative;
  display: flex;
  flex-direction: column;
}

.form-box {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
}

.panel-footer {
  display: flex;
  color: #fff;
}

.panel-footer .btn {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.panel-footer .btn-save {
  background: #006ab1;
}

.panel-footer .btn-cancel {
  background: #9e9e9e;
}

/deep/ {
  .el-switch__label {
    color: #fff !important;
    width: 70px;
  }

  .switch-item {
    width: 150px;
    margin-bottom: 10px;
  }

  .el-form--label-top .el-form-item__label {
    color: #fff !important;
  }
}
</style>
